<template>
  <div class="bannerContainer">
    <a-carousel
      arrows
      dots-class="slick-dots slick-thumb"
      dot-position="bottom"
      :before-change="onChange"
      autoplay
    >
      <div class="carousel-img" v-for="item in images" :key="item">
        <img :src="item" />
      </div>
    </a-carousel>
    <div class="Mask">
      <span @click="handleDrawer">
        <a-icon type="plus" class="plus" />
      </span>
    </div>

    <Drawer
      :title="'banner配置'"
      :visible="showDrawer"
      @handleOk="handleSubmit"
      @handleCancel="handleDrawer"
    >
      <a-form :form="form" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item label="上传图片">
          <UploadImage :isThumb="true" @handleFileList="handleFileList" />
          <span class="pdf"
            >支持扩展名：.jpg,
            .png（请上传的文件小于500M，否则上传不成功）</span
          >
        </a-form-item>
      </a-form>
    </Drawer>
  </div>
</template>
<script>
const img1 = require('@/assets/abstract01.jpeg');
const img2 = require('@/assets/index.jpg');
import Drawer from '@/components/common/Drawer';
import UploadImage from '@/components/common/UploadImage';
export default {
  data() {
    return {
      images: [img1, img2],
      showDrawer: false,
      form: this.$form.createForm(this),
      labelCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 5,
        },
      },
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 16,
        },
      },
      bannerList: [],
    };
  },
  components: {
    Drawer,
    UploadImage,
  },

  methods: {
    onChange(from, to) {
      console.log(from, to);
    },
    handleDrawer() {
      this.showDrawer = !this.showDrawer;
    },
    handleFileList(fileList) {
      this.bannerList = fileList;
      console.log('=============', fileList);
    },
    handleSubmit() {
      this.handleDrawer();
    },
  },
};
</script>
<style scoped>
/* For demo */
.ant-carousel >>> .slick-slide {
  text-align: center;
  height: 160px;
  line-height: 160px;
  background: #364d79;
  overflow: hidden;
}

.ant-carousel >>> .slick-slide h3 {
  color: #fff;
}
.bannerContainer {
  width: 100%;
  position: relative;
}
.Mask {
  width: 100%;
  height: 160px;
  background-color: rgba(0, 0, 0, 0.45);
  position: absolute;
  top: 0;
  opacity: 1;
  text-align: center;
  line-height: 200px;
}
.plus {
  color: #fff;
  font-size: 60px;
  text-align: center;
}
.carousel-img {
  width: 100%;
}
.carousel-img img {
  width: 100%;
  height: 160px;
}
</style>
